package com.milta.feature.legal.domain.entity

/** The two legal documents exposed by `GET /api/v1/legal-documents/{type}` (backend repo). */
enum class LegalDocumentType {
    TermsOfUse,
    PrivacyPolicy,
}

/** Maps to the backend's URL slug — never compare/hardcode these strings elsewhere. */
val LegalDocumentType.urlSlug: String
    get() = when (this) {
        LegalDocumentType.TermsOfUse -> "terms-of-use"
        LegalDocumentType.PrivacyPolicy -> "privacy-policy"
    }
